import EditableField from '../EditableField';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Plus, Trash2, Copy, Pencil, X } from 'lucide-react';
import { toast } from 'sonner';
import { SIM_NETWORKS } from '../../../utils/bankConstants';

const SimTab = ({ editData, updateField, canEdit, simInputs, setSimInputs, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit }) => {
  const editProps = { canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit };

  const handleCopy = async (text, label) => {
    try { await navigator.clipboard.writeText(text); toast.success(`${label} copied!`); }
    catch { toast.error('Failed to copy'); }
  };

  const handleAddSIM = () => setSimInputs([...simInputs, { number: '', network: '' }]);
  const handleRemoveSIM = (index) => {
    const n = simInputs.filter((_, i) => i !== index);
    setSimInputs(n.length > 0 ? n : [{ number: '', network: '' }]);
  };
  const handleSIMChange = (index, field, value) => {
    const n = [...simInputs]; n[index][field] = value; setSimInputs(n);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Card className="p-2 divide-y">
          <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">SIM Settings</h3></div>
          <div className="flex items-center justify-between py-2 px-3 hover:bg-slate-50 group">
            <div className="flex-1">
              <span className="text-xs text-slate-500 block">SIM Available</span>
              {editingField === 'simAvailable' ? (
                <div className="flex items-center gap-2 mt-1">
                  <Select value={editingValue || 'yes'} onValueChange={(val) => { updateField('simAvailable', val); cancelEdit(); }}>
                    <SelectTrigger className="h-8 w-32"><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="yes">Yes</SelectItem><SelectItem value="no">No</SelectItem></SelectContent>
                  </Select>
                  <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500" onClick={cancelEdit}><X className="w-4 h-4" /></Button>
                </div>
              ) : (<span className="text-sm font-medium text-slate-800">{editData.simAvailable === 'yes' ? 'Yes' : 'No'}</span>)}
            </div>
            {editingField !== 'simAvailable' && canEdit && (
              <Button variant="ghost" size="sm" className="h-7 w-7 p-0 opacity-0 group-hover:opacity-100 transition-opacity" onClick={() => startEditing('simAvailable', editData.simAvailable)}>
                <Pencil className="w-3 h-3 text-blue-500" />
              </Button>
            )}
          </div>
          <EditableField field="simLocation" label="SIM Location" value={editData.simLocation} {...editProps} customEditRenderer={(field, value) => (
            <Select value={value || ''} onValueChange={(val) => { updateField(field, val); cancelEdit(); }}>
              <SelectTrigger data-testid="edit-input-simLocation" className="h-8 w-40"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                {['ESIM / I', 'ESIM / D', 'I', 'D'].map(loc => <SelectItem key={loc} value={loc}>{loc}</SelectItem>)}
              </SelectContent>
            </Select>
          )} />
        </Card>
        <Card className="p-2 divide-y"><EditableField field="notes" label="Notes / Remarks" value={editData.notes} {...editProps} /></Card>
      </div>
      <Card className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-sm">SIM Cards ({simInputs.length})</h3>
          <Button type="button" onClick={handleAddSIM} variant="outline" size="sm" className="gap-2"><Plus className="w-4 h-4" />Add SIM</Button>
        </div>
        <div className="space-y-3 max-h-64 overflow-y-auto">
          {simInputs.map((sim, index) => (
            <div key={`sim-${sim.number || index}`} className="flex gap-2 items-start p-3 bg-slate-50 rounded-lg">
              <div className="flex-1 space-y-2">
                <div className="flex gap-2 items-center">
                  <Input placeholder="10-digit phone number" value={sim.number} maxLength={10} onChange={(e) => handleSIMChange(index, 'number', e.target.value.replace(/\D/g, '').slice(0, 10))} />
                  {sim.number && <Button variant="ghost" size="sm" onClick={() => handleCopy(sim.number, `SIM ${index + 1}`)} className="h-8 w-8 p-0"><Copy className="w-4 h-4" /></Button>}
                </div>
                <Select value={sim.network} onValueChange={(val) => handleSIMChange(index, 'network', val)}>
                  <SelectTrigger><SelectValue placeholder="Network" /></SelectTrigger>
                  <SelectContent>{SIM_NETWORKS.map(n => <SelectItem key={n} value={n}>{n}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              {simInputs.length > 1 && (
                <Button type="button" onClick={() => handleRemoveSIM(index)} variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50"><Trash2 className="w-4 h-4" /></Button>
              )}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default SimTab;
